module.exports = __webpack_public_path__ + "static/media/card_brand_hipercard.25fa3a2f.svg";